import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { industrySelections } from '../../../../constants';
import BootstrapInput from '../../../shared/components/OutlinedInputBox';
import '../CompanySignUp.css';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import HpTooltip from '../../../../components/shared/components/hpTooltip';

const styles = theme => ({
  mission: {
    marginTop: '35px',
    textAlign: 'center'
  },
  industry: {
    width: '100%',
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  industryMenu: {
    maxHeight: 0,
    '& .MuiPopover-paper': {
      minHeight: 250
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px'
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  },
  titleContainer: {
    textAlign: 'center'
  }
});

class CompanyInfo extends React.Component {
  constructor() {
    super();

    this.initialState = {
      submitAttempted: false,
      industryError: '',
      missionError: ''
    };

    this.state = {
      ...this.initialState
    };
  }

  handleNextClick = () => {
    this.setState({
      submitAttempted: true
    });

    if (!this.props.companyInfo.industry) {
      this.setState({
        industryError: 'Industry is required.'
      });
    } else {
      this.setState({
        industryError: ''
      });
    }

    if (!this.props.companyInfo.mission) {
      this.setState({
        missionError: 'Mission is required.'
      });
    } else {
      this.setState({
        missionError: ''
      });
    }

    if (this.props.companyInfo.industry && this.props.companyInfo.mission) {
      this.props.handleNext();
    }
  };

  render() {
    const { classes, companyInfo, changeHandler, handleBack } = this.props;

    return (
      <React.Fragment>
        <Grid container spacing={40} justify="center" direction="column">
          <Grid
            item
            xs={12}
            sm={12}
            className="industry-select"
            style={{ width: '100%' }}
          >
            <div className={classes.titleContainer}>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                display="inline"
              >
                Our industry is
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={
                  'Select the industry which most closely matches your own.'
                }
              />
            </div>
            <TextField
              id="industry"
              name="industry"
              select
              className={classes.industry}
              value={companyInfo.industry}
              onChange={changeHandler}
              SelectProps={{
                MenuProps: {
                  className: classes.industryMenu
                }
              }}
              margin="normal"
              variant="outlined"
              error={
                this.state.submitAttempted && this.state.industryError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.industryError : ''
              }
            >
              {industrySelections.map((item, i) => (
                <MenuItem key={i} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            className={classes.mission}
            style={{ width: '100%' }}
          >
            <div className={classes.titleContainer}>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                display="inline"
              >
                Our company mission is
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={'Enter a short description of your company mission.'}
              />
            </div>
            <TextField
              id="mission"
              name="mission"
              className="mission-input"
              margin="normal"
              variant="outlined"
              onChange={changeHandler}
              error={
                this.state.submitAttempted && this.state.missionError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.missionError : ''
              }
            />
            <Typography
              variant="subtitle2"
              gutterBottom
              align="center"
              className="mission-helper-text"
              color="textSecondary"
            >
              Example:
              <br />
              Expand our e-sports brand recognition
              <br />
              Be the world's top peanut butter distributer
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.buttons}>
          <Button onClick={handleBack} className={classes.backButton}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleNextClick.bind(this)}
            className={classes.nextButton}
          >
            Next
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(CompanyInfo);



// WEBPACK FOOTER //
// ./src/components/sign-up/company/components/CompanyInfo.js